import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, useEffect, useState } from "react";
import { LuImagePlus } from "react-icons/lu";
import Select from "react-select";
import { addVehicle, getOwners, updateVehicle } from "../../../api/vehicle.api";
import { errorMsg, success } from "../../../utils/notifications";
import { baseURL } from "../../../api/api";

const serviceTypes = [
  { value: "Bolt", label: "Bolt" },
  { value: "Uber", label: "Uber" },
  { value: "Yango", label: "Yango" },
  { value: "VTC", label: "VTC" },
  { value: "Taxi", label: "Taxi" },
];
const locations = ["Paris, France", "Douala, Cameroon", "Yaoundé, Cameroon"];
const AddVehicle = ({
  open,
  setOpen,
  fetchVehicles,
  initialData,
  vehiclesData,
}) => {
  const [addVehicleData, setAddVehicleData] = useState(
    initialData || vehiclesData
  );
  const [ownerId, setOwnerId] = useState(null); // Owner ID now set from dropdown
  const [ownerData, setOwnerData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [validationErrors, setValidationErrors] = useState({
    owner: "",
    location: "",
    status: "",
  });

  // Set initial owner and vehicle data
  useEffect(() => {
    if (vehiclesData) {
      setAddVehicleData({
        ...vehiclesData,
        serviceType: vehiclesData.type, // Ensure correct value
      });
      setOwnerId(vehiclesData.owner);
      setSelectedOwner({
        value: vehiclesData.owner,
        label: ownerData?.find((owner) => owner._id === vehiclesData.owner)
          ?.name,
      });
    } else {
      setAddVehicleData(initialData);
      setOwnerId(null);
      setSelectedOwner(null);
    }
  }, [vehiclesData, ownerData]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    console.log("image is", file);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setAddVehicleData({
      ...addVehicleData,
      [name]: value,
    });
  };

  // Fetch owners
  useEffect(() => {
    getOwners()
      .then((res) => {
        setOwnerData(res?.data?.owners);
        console.log(res?.data?.owners);
      })
      .catch((error) => {
        console.error("Error fetching owners:", error);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {
      owner:
        !vehiclesData?._id && !addVehicleData?.owner ? "Owner is required" : "",
      location: !addVehicleData?.location ? "Location is required" : "",
      status: !addVehicleData?.status ? "Status is required" : "",
    };

    setValidationErrors(errors);

    const hasErrors = Object.values(errors).some((err) => err !== "");
    if (hasErrors) return;
    const formData = new FormData();
    formData.append(
      "image",
      selectedFile !== null ? selectedFile : addVehicleData?.image
    );
    formData.append("brand", addVehicleData?.brand);
    formData.append("model", addVehicleData?.model);
    formData.append("type", addVehicleData?.serviceType); // Updated field
    formData.append("status", addVehicleData?.status); // Updated field
    formData.append("registrationNumber", addVehicleData?.registrationNumber);
    formData.append("location", addVehicleData?.location);
    formData.append("owner", ownerId || addVehicleData?.owner); // Use ownerId or existing owner

    if (vehiclesData?._id) {
      updateVehicle(vehiclesData._id, formData)
        .then((res) => {
          console.log(res?.data);
          setAddVehicleData(initialData);
          setSelectedOwner(null);
          setSelectedFile(null);
          success("Successful", "Mobile Location Updated Successfully");
          fetchVehicles();
          setOpen(false);
        })
        .catch((err) => {
          errorMsg("Oops", err?.response?.data?.message);
          console.log("Error is", err);
        });
    } else {
      addVehicle(formData)
        .then((res) => {
          console.log(res?.data);
          setAddVehicleData(initialData);
          setSelectedOwner(null);
          setSelectedFile(null);
          setOpen(false);
          success("Successful", "Mobile Location Added Successfully");
          fetchVehicles();
        })
        .catch((err) => {
          errorMsg("Oops", err?.response?.data?.message);
          console.log(err);
        });
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="z-50" onClose={setOpen}>
        <Transition.Child
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-300"
          leaveFrom="opacity-100 transform scale-100"
          leaveTo="opacity-0 transform scale-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-500"
              enterFrom="opacity-0 transform scale-0"
              enterTo="opacity-100 transform scale-100"
              leave="ease-in duration-300"
              leaveFrom="opacity-100 transform scale-100"
              leaveTo="opacity-0 transform scale-0"
            >
              <Dialog.Panel className="mt-12 lg:ml-60 md:ml-60 ml-0 z-50 lg:w-1/2 md:w-1/2 w-4/5 fixed mx-auto rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all h-auto">
                <div className="absolute top-0 right-0 pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="">
                  <div className=" sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="px-3 pb-5 text-xl font-medium border-b-2 border-gray-200 leading-6 text-gray-700"
                    >
                      {vehiclesData?._id
                        ? "Update Mobile Location"
                        : "Add Mobile Location"}
                    </Dialog.Title>
                    <div className="">
                      <form onSubmit={handleSubmit} method="POST">
                        <div className="h-[30rem] overflow-y-scroll">
                          <div className="px-7 py-4">
                            <div className="flex items-center justify-between">
                              <div>
                                <h2 className="text-lg font-semibold text-gray-300 ">
                                  Mobile Location Information
                                </h2>
                              </div>
                            </div>
                            <div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12">
                                  <label
                                    htmlFor="vehicleImage"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Image
                                  </label>
                                </div>
                                <div className="text-left lg:col-span-7 md:col-span-7 sm:col-span-12">
                                  <div className="w-1/3 mt-2">
                                    <label
                                      htmlFor="image"
                                      className="mx-auto bg-gray-100 rounded-lg h-28 w-28 inset-0 flex items-center justify-center cursor-pointer overflow-hidden"
                                    >
                                      {selectedFile ||
                                      (vehiclesData?._id &&
                                        vehiclesData?.image) ? (
                                        <img
                                          src={
                                            selectedFile
                                              ? URL.createObjectURL(
                                                  selectedFile
                                                )
                                              : `${baseURL}/s3/images/${addVehicleData?.image}`
                                          }
                                          alt="Selected"
                                          className="h-full w-full object-cover"
                                        />
                                      ) : (
                                        <LuImagePlus className="text-gray-400 h-14 w-14 p-2" />
                                      )}
                                    </label>
                                    <input
                                      type="file"
                                      name="image"
                                      id="image"
                                      className="hidden"
                                      onChange={handleFileChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              {!vehiclesData?._id && (
                                <>
                                  <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                    <div className="lg:col-span-5 md:col-span-5 sm:col-span-12">
                                      <label
                                        htmlFor="owner"
                                        className="block text-base font-semibold leading-6 text-gray-800"
                                      >
                                        Select Owner{" "}
                                        <span className="text-red-500">*</span>
                                      </label>
                                    </div>
                                    <div className="lg:col-span-7 md:col-span-7 sm:col-span-12">
                                      <div className="mt-2">
                                        <Select
                                          name="vehicle"
                                          id="select-owner"
                                          options={ownerData?.map((owner) => ({
                                            value: owner?._id,
                                            label: owner?.name,
                                          }))}
                                          required
                                          value={selectedOwner}
                                          className="basic-multi-select"
                                          classNamePrefix="select Vehicle"
                                          onChange={(selectedOption) => {
                                            setAddVehicleData({
                                              ...addVehicleData,
                                              owner: selectedOption.value, // Update the owner in vehicle data
                                            });
                                            setValidationErrors((prev) => ({
                                              ...prev,
                                              owner: "",
                                            }));
                                            setOwnerId(selectedOption.value); // Update the owner ID state
                                            setSelectedOwner(selectedOption); // Update the selected owner for the dropdown
                                          }}
                                        />
                                        {validationErrors.owner && (
                                          <p className="text-red-500 text-sm mt-1">
                                            {validationErrors.owner}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="brand"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Brand{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="brand"
                                      placeholder="Enter Vehicle Brand"
                                      value={addVehicleData?.brand}
                                      onChange={handleChange}
                                      id="brand"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="model"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Model{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="model"
                                      placeholder="Enter Vehicle Model"
                                      value={addVehicleData?.model}
                                      onChange={handleChange}
                                      id="model"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="registrationNumber"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Registration Number{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="registrationNumber"
                                      placeholder="Enter Registration Number"
                                      value={addVehicleData?.registrationNumber}
                                      onChange={handleChange}
                                      id="registrationNumber"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12">
                                  <label
                                    htmlFor="service-type"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Select Service / Type{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12">
                                  <div className="mt-2">
                                    <Select
                                      name="service-type"
                                      id="select-service-type"
                                      options={serviceTypes}
                                      value={serviceTypes.find(
                                        (option) =>
                                          option.value ===
                                          addVehicleData?.serviceType // Ensure correct match
                                      )}
                                      className="basic-multi-select"
                                      classNamePrefix="select Service Type"
                                      onChange={(selectedOption) => {
                                        setAddVehicleData({
                                          ...addVehicleData,
                                          serviceType: selectedOption?.value,
                                        });
                                      }}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>{" "}
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="location"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Select Location{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <Select
                                      name="location"
                                      options={locations.map((location) => ({
                                        value: location,
                                        label: location,
                                      }))}
                                      value={{
                                        value: addVehicleData?.location,
                                        label: addVehicleData?.location,
                                      }}
                                      className="basic-multi-select"
                                      classNamePrefix="select location"
                                      onChange={(selectedOption) => {
                                        setAddVehicleData({
                                          ...addVehicleData,
                                          location: selectedOption?.value,
                                        });
                                        setValidationErrors((prev) => ({
                                          ...prev,
                                          location: "",
                                        }));
                                      }}
                                      required
                                    />
                                    {validationErrors.location && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {validationErrors.location}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="status"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Select Status{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <Select
                                      name="status"
                                      id="status"
                                      options={[
                                        {
                                          value: "Approved",
                                          label: "Approved",
                                        },
                                        {
                                          value: "Pending Approval",
                                          label: "Pending Approval",
                                        },
                                      ]}
                                      value={{
                                        value: addVehicleData?.status,
                                        label: addVehicleData?.status,
                                      }}
                                      className="basic-multi-select"
                                      classNamePrefix="select status"
                                      onChange={(selectedOption) => {
                                        setAddVehicleData({
                                          ...addVehicleData,
                                          status: selectedOption?.value,
                                        });
                                        setValidationErrors((prev) => ({
                                          ...prev,
                                          status: "",
                                        }));
                                      }}
                                      required
                                    />
                                    {validationErrors.status && (
                                      <p className="text-red-500 text-sm mt-1">
                                        {validationErrors.status}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-t-2 border-gray-200 px-7 pt-3 flex items-center justify-end">
                          <button
                            type="submit"
                            className="flex justify-center rounded-md bg-yellowColor px-3 py-2.5 px-10 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
                          >
                            {vehiclesData?._id ? "Update" : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AddVehicle;
